<template>
  <div>
    <el-card>
      <BarChart />
    </el-card>
    <el-card>
      <div class="row">
          <div class="col-md-12">
            <h5 class="card-title">メニュー別割合</h5>
              <div class="p-2">
                <div class="row">
                  <div class="col-xs-12 col-md-12 p-0">
                    <div>
                      <PieChartCategories />
                    </div>
                  </div>
                </div>
              </div>
          </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import BarChart from "./sale_managers/BarChart";
import PieChartCategories from './sale_managers/PieChartCategories';
export default {
  name: "SaleManagers",
  components:{
    BarChart, PieChartCategories
  },
  methods:{
  }
}
</script>


<style scoped>

</style>
